import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { UserStore } from '@core/services/user/user.store'
import { AuthService } from '@core/services/auth-service/auth.service'
import { environment } from 'src/environments/environment'
import { authEndpoints } from '@app/core/constants/valueConstants'

function redirectToSignIn(): false {
    const currentUrl = window.location.href
    const signinUrl = `${environment.ssoBaseUrl}${authEndpoints.SIGNIN_PATH}?next=${encodeURIComponent(currentUrl)}`
    window.location.href = signinUrl
    return false
}

export const authGuard: CanActivateFn = async () => {
    const userStore = inject(UserStore)
    if (userStore.userData()) {
        return true
    }

    const authService = inject(AuthService)
    const authenticated = await authService.isAuthenticated()
    if (authenticated) {
        return true
    }

    return redirectToSignIn()
}
